export class PrintSinotticoOUTModel {
    downloadURL: string
    ref: string
    statusURL: string
}
